import React from 'react';
import { Modal, Typography } from 'antd';
import GridLayout from '../../../../shared/ui/GridLayout';
import ContentTitle from '../components/ContentTitle';
import ParentList from '../components/ParentList';
import ChildList from '../components/ChildList';

const title = 'Часть помещений дома связана с помещениями других домов';

export const createConfirm = ({
  onOk,
  parentRooms,
  childRooms,
  currentHouseId,
}) => {
  Modal.confirm({
    title,
    content: (
      <Content
        parentRooms={parentRooms}
        childRooms={childRooms}
        currentHouseId={currentHouseId}
      />
    ),
    centered: true,
    onCancel: () => {},
    onOk,
  });
};

function Content({ parentRooms, childRooms, currentHouseId }) {
  return (
    <div>
      <GridLayout>
        {Boolean(parentRooms?.length) && (
          <div>
            <ContentTitle>
              Помещения, к которым привязаны помещения других домов
            </ContentTitle>

            {parentRooms.map((room) => (
              <ParentList roomData={room} key={room.id} />
            ))}
          </div>
        )}

        {Boolean(childRooms?.length) && (
          <div>
            <ContentTitle>
              Помещения, которые привязаны к помещениям других домов
            </ContentTitle>

            {childRooms.map((room) => (
              <ChildList
                key={room.id}
                roomData={room}
                currentHouseId={currentHouseId}
              />
            ))}
          </div>
        )}
      </GridLayout>
      <Typography.Paragraph>Продолжить?</Typography.Paragraph>
    </div>
  );
}
